/**
 * Get Communities Use Case
 * Business logic for retrieving communities list
 */

import type { CommunitiesRepository } from '../data/communities-repository';
import type { GetCommunitiesResponse } from '../types/communities-types';

export class GetCommunitiesUseCase {
  constructor(private readonly repository: CommunitiesRepository) {}

  /**
   * Execute use case to get communities
   * @param includeExpired - Whether to include expired communities
   * @param actorId - Optional actor ID filter
   */
  async execute(
    includeExpired: boolean,
    actorId?: number | null
  ): Promise<GetCommunitiesResponse> {
    try {
      // Filter out null actorId
      const filteredActorId = actorId ?? undefined;

      const response = await this.repository.getCommunities(includeExpired, filteredActorId);

      return response;
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Failed to load communities';
      throw new Error(message);
    }
  }
}
